import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
import "./registerServiceWorker";
import "@/assets/css/tailwind.css";
import "../node_modules/animate.css";
import "../node_modules/vue2-timepicker/dist/VueTimepicker.css";
import VueLoading from "vuejs-loading-plugin";
import VueClipboard from "vue-clipboard2";
import VModal from "vue-js-modal";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);
Vue.use(VModal, { dialog: true });
Vue.use(VueLoading);
Vue.use(VueClipboard);

Vue.config.productionTip = false;

var firebaseConfig = {
  apiKey: "AIzaSyAOa5na3GARTHEAqwwMFxEaVRZb2ofOUxY",
  authDomain: "push-ad448.firebaseapp.com",
  databaseURL: "https://push-ad448.firebaseio.com",
  projectId: "push-ad448",
  storageBucket: "gs://push-ad448.appspot.com",
  messagingSenderId: "514762482600",
  appId: "1:514762482600:web:1e4820f757481b53"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
//firebase.analytics();

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
  store.dispatch("getProfile", user);

  if (
    router.currentRoute.name === "groupsingle" ||
    router.currentRoute.name === "poll" ||
    router.currentRoute.name === "eventsingle"
  ) {
    return;
  } else {
    if (!user) {
      router.replace({ name: "login" });
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
